import { type ObjectType } from "@incloodsolutions/toolkit/interface";

export type EnvironmentName = 'development' | 'staging' | 'production';

// The deployed locations of every Workinance app, shared so no app keeps its own copy of another's URL.
// Each app only chooses which environment is active (scripts/setEnvironment.mjs rewrites that choice).

// TODO: confirm the real staging/production API URLs once deployed.
// No `/api` segment, in local or deployed (see server/src/app.ts). `/v1` is the API's URI version;
// a future `v2` would get its own entry here once routes need it.
export const apiEndpoints: ObjectType<string, EnvironmentName> = {
	development: 'http://localhost:3300/v1',
	staging: 'https://mbahh5yqpd.execute-api.us-east-1.amazonaws.com/v1',
	production: 'https://api.workinance.com/v1',
};

export const dashboardEndpoints: ObjectType<string, EnvironmentName> = {
	development: 'http://localhost:5173',
	staging: 'https://staging.workinance.com',
	production: 'https://app.workinance.com',
};

export const adminEndpoints: ObjectType<string, EnvironmentName> = {
	development: 'http://localhost:5174',
	staging: 'https://staging-admin.workinance.com',
	production: 'https://admin.workinance.com',
};

// The public marketing site (the landing app).
export const websiteEndpoints: ObjectType<string, EnvironmentName> = {
	development: 'http://localhost:3000',
	staging: 'https://www.workinance.com',
	production: 'https://www.workinance.com',
};
